import React from 'react';

import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

export interface IconAvatarLumaBotProps extends SvgIconProps {}

const IconAvatarLumaBot: React.FC<IconAvatarLumaBotProps> = ({ ...rest }) => (
  <SvgIcon viewBox="0 0 156 153" {...rest}>
    <g filter="url(#filter0_d_205_3415)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M82 29.9297C84.3912 28.5465 86 25.9611 86 23C86 18.5817 82.4183 15 78 15C73.5817 15 70 18.5817 70 23C70 25.9611 71.6088 28.5465 74 29.9297V37H66.7127C63.2461 37 60.3932 39.6277 60.0374 43H37.472C27.2702 43 19 51.2702 19 61.472V110.528C19 120.73 27.2702 129 37.472 129H118.528C128.73 129 137 120.73 137 110.528V61.472C137 51.2702 128.73 43 118.528 43H95.9626C95.6068 39.6277 92.7539 37 89.2873 37H82V29.9297Z"
        fill={rest.color === 'primary' ? rest.color : 'url(#paint0_linear_205_3415)'}
      />
      <g filter="url(#filter1_d_205_3415)">
        <rect x="32.9999" y="63" width="90" height="44" rx="20.7509" fill="#FFF8F4" />
      </g>
      <circle cx="55.902" cy="84.902" r="9.90203" fill="#172537" />
      <circle cx="61.513" cy="81.2773" r="2.97061" fill="white" />
      <circle cx="98.811" cy="84.902" r="9.90203" fill="#172537" />
      <circle cx="104.422" cy="81.2773" r="2.97061" fill="white" />
    </g>
    <defs>
      <filter
        id="filter0_d_205_3415"
        x="0.214941"
        y="0.911206"
        width="155.57"
        height="151.57"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4.69626" />
        <feGaussianBlur stdDeviation="9.39253" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_205_3415" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_205_3415" result="shape" />
      </filter>
      <filter
        id="filter1_d_205_3415"
        x="20.4766"
        y="50.4766"
        width="115.047"
        height="69.0468"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="6.26169" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_205_3415" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_205_3415" result="shape" />
      </filter>
      <linearGradient
        id="paint0_linear_205_3415"
        x1="122.842"
        y1="145.437"
        x2="120.645"
        y2="80.4063"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FB2D00" />
        <stop offset="1" stopColor="#FE7235" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export default IconAvatarLumaBot;
